export default __webpack_public_path__ + "static/media/apple-logo.d0b122d4.svg";